/* KP custom: stylekorean-style hero card carousel (kp-hero-banner section) */
if (!customElements.get('kp-hero-slider')) {
  class KpHeroSlider extends HTMLElement {
    connectedCallback() {
      this.initWhenReady();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', event => {
          if (event.target.contains(this)) {
            this.destroy();
            this.initWhenReady();
          }
        });
        document.addEventListener('shopify:block:select', event => {
          if (this.swiper && event.target.closest('kp-hero-slider') === this) {
            this.swiper.slideToLoop(Number(event.target.dataset.index || 0), 400);
          }
        });
      }
    }

    disconnectedCallback() {
      this.destroy();
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initWhenReady() {
      if (window.Swiper) {
        this.init();
      } else {
        window.addEventListener('load', () => this.init(), { once: true });
      }
    }

    init() {
      if (this.swiper || !window.Swiper) return;

      const configEl = this.querySelector('[data-kp-hero-config]');
      const cfg = configEl ? JSON.parse(configEl.textContent) : {};
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      const options = {
        slidesPerView: 1.15,
        centeredSlides: true,
        spaceBetween: 16,
        speed: cfg.speed || 750,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: cfg.gap != null ? cfg.gap : 18
          }
        }
      };

      if (cfg.loop) {
        options.loop = true;
      } else {
        options.rewind = true;
      }

      if (cfg.autoplay) {
        options.autoplay = {
          delay: cfg.autoplay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      const paginationEl = this.querySelector('.kp-hero__pagination');
      if (cfg.pagination && paginationEl) {
        options.pagination = { el: paginationEl, clickable: true };
      }

      const nextEl = this.querySelector('.kp-hero__btn--next');
      const prevEl = this.querySelector('.kp-hero__btn--prev');
      if (cfg.navigation && nextEl && prevEl) {
        options.navigation = { nextEl, prevEl };
      }

      this.swiper = new Swiper(swiperEl, options);
    }
  }
  customElements.define('kp-hero-slider', KpHeroSlider);
}
